import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=4ffce9ae&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffce9ae')) {
      api.createRecord('4ffce9ae', component.options)
    } else {
      api.reload('4ffce9ae', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=4ffce9ae&", function () {
      api.rerender('4ffce9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22EhOgjO6jB0j/JS/comp/costHelpSpa.vue"
export default component.exports